<template>
    <div class="work-team">

        <!-- Search for new Users -->
        <work-team-search v-if="project.is_not_completed && selectedVersion" :project="project" :version="selectedVersion" @invited="invitedUserEvent"></work-team-search>

        <!-- Version Missing Alert -->
        <div v-if="!selectedVersion" class="alert alert-warning">
            <i class="fas fa-exclamation-circle"></i> Select the Energy Code Version in the Project Information tab.
        </div>

        <!-- Invited Users -->
        <div class="table-container">
            <table class="table table-hover">
                <thead>
                <tr>
                    <th>Name</th>
                    <th class="text-center">Lead ATT</th>
                    <th class="text-center">Remove</th>
                </tr>
                </thead>
                <tbody>
                <tr is="work-team-invited-user"
                    v-for="user in usersList"
                    :key="user.id"
                    :user="user"
                    :project="project"
                    @remove="removedUserEvent">
                </tr>
                </tbody>
            </table>
        </div>

        <!-- Legend -->
        <div class="legend">
            <div class="item employer">
                <div class="square"></div> ATE
            </div>
            <div class="item technician">
                <div class="square"></div> ATT
            </div>
            <div class="item responsible">
                <div class="square"></div> Lead ATT
            </div>
        </div>
    </div>
</template>
<script>
    export default {

        props:{
            value:{
                type: Object,
                required: true,
            },
            readonly: {
                required: false,
                type: Boolean,
                default: false,
            },
            version:{
            }
        },

        data () {
            return {
                selectedVersion: this.version,
                project: this.value,
                users: this.value.users,
            }
        },

        created() {
            App.bus.$on(`${this.project.slug}-responsible`, responsible => {
                this.users.forEach(user => {
                    user.invited.is_responsible = responsible.id == user.id;
                })
            })
        },

        methods: {
            invitedUserEvent(user) {
                this.users.unshift(user);
            },

            removedUserEvent(user) {
                var index = this.users.indexOf(user)
                this.users.splice(index, 1)
            }
        },

        watch:{
            value(){
                this.project = this.value;
            },
            version(){
                this.selectedVersion = this.version;
            }
        },

        computed:{
            usersList() {
                return _.sortBy(this.users, user => {
                    return !user.invited.is_employer;
                });
            }
        }
    }
</script>
